import { useEffect } from "react";
import StructureEstimateActionButtons from "./StructureEstimateActionButtons";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { updateConveyor } from "../../modules/conveyor/conveyorWriteSlice";




const StructureEstimateActionButtonsContainer = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    // const { title, body, tags, conveyor, conveyorError, originalConveyorId } = useSelector(({ conveyorWrite }) => ({
    //     title: conveyorWrite.title,
    //     body: conveyorWrite.body,
    //     tags: conveyorWrite.tags,
    //     conveyor: conveyorWrite.conveyor,
    //     conveyorError: conveyorWrite.conveyorError,
    //     originalConveyorId: conveyorWrite.originalConveyorId,
    // }));

    const title = useSelector(state => state.conveyorWrite.title);
    const body = useSelector(state => state.conveyorWrite.body);
    const tags = useSelector(state => state.conveyorWrite.tags);
    const conveyor = useSelector(state => state.conveyorWrite.conveyor);
    const conveyorError = useSelector(state => state.conveyorWrite.conveyorError);
    const originalConveyorId = useSelector(state => state.conveyorWrite.originalConveyorId);

    // 컨베이어 저장
    const onPublish = () => {
        if (originalConveyorId) {
            dispatch(updateConveyor({ title, body, tags, id: originalConveyorId }),);
        }
        return;
        /* 에러 처리 */
        
        /* 새로 작성은 없기 때문에 writeConveyor를 할 필요가 없다 */
    };

    const onCancel = () => {
        navigate(-1);
    };

    // 성공 혹은 실패 시 할 작업
    useEffect(() => {
        if (conveyor) {
            // conveyor 객체는 write, update에 성공했을 때 적는 객체임.
            /* 서버에서 리턴 받은 conveyor 객체 -> state에 저장
                conveyor: {
                    title: '봄 나들이',
                    body: ' ...... ',
                    tags: ['태그1', '태그2', ...... ],
                    user: {
                        _id: 'xxxxxxxxxxxxxxxxx',
                        username: 'nero',
                    },
                    _id: '62038324819047192034jdafk839402',
                    publishedDate: '2022-04-12T07:36:33.527z',
                    __v: 0
                }
            */

            // conveyorEditorContainer에서 작동이 이상해서 이쪽으로 임시방편으로 옮겨둠. 작동은 됨. '24.1/8
            // dispatch(initialize());
            // 상기 문제 해결. '24.1/8

            //const { _id } = conveyor;
            //navigate(`/conveyors/${_id}`); // ConveyorPage 호출 -> ConveyorViewerContainer
            
            // 상기처럼 하지 말고 그냥 호출한 페이지로 가자.
            navigate(-1);
        }
        if (conveyorError) {
            console.error(conveyorError);
        }
    }, [dispatch, navigate, conveyor, conveyorError]);

    return (
        <StructureEstimateActionButtons isEdit={!!originalConveyorId} onPublish={onPublish} onCancel={onCancel} />
    );
};

export default StructureEstimateActionButtonsContainer;